// components/ExpirationAlert.jsx
import React from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router';

const ExpirationAlert = ({ doctor }) => {
    const navigate = useNavigate();

    // ১. ডাটা চেক (কনসোল ওপেন করে দেখুন ডাটা আসছে কিনা)
    // console.log("Doctor Data in Alert:", doctor); 

    if (!doctor || !doctor.subscription_end_date) return null;

    const endDate = moment(doctor.subscription_end_date);
    const today = moment();
    
    // দিন পার্থক্য বের করা
    const daysRemaining = endDate.diff(today, 'days');

    // console.log("Days Remaining:", daysRemaining);

    // ২. মেয়াদ শেষ (Expired)
    if (daysRemaining < 0) {
        return (
            <div className="bg-red-600 text-white px-6 py-3 shadow-lg flex flex-col md:flex-row justify-between items-center z-50 relative animate-pulse">
                <div className="flex items-center gap-3 mb-2 md:mb-0">
                    <span className="text-2xl">⚠️</span>
                    <div>
                        <p className="font-bold text-lg">Subscription Expired on {endDate.format('YYYY-MM-DD')}</p>
                        <p className="text-sm text-red-100">Please renew your plan to create prescriptions.</p>
                    </div>
                </div>
                <button 
                    onClick={() => navigate('/subscription')}
                    className="bg-white text-red-600 px-6 py-2 rounded-full font-bold hover:bg-gray-100 transition shadow"
                >
                    Renew Now
                </button>
            </div>
        );
    }

    // ৩. টেস্টিং এর জন্য এখানে ৪০ দিন দিন (আগে ৭ ছিল)
    // কাজ করলে পরে আবার ৭ করে দেবেন।
    if (daysRemaining < 7) { 
        return (
            <div className="bg-linear-to-r from-yellow-400 to-orange-400 text-black px-4 py-3 shadow-md flex justify-between items-center z-40 relative">
                <div className="flex items-center gap-2">
                    <span className="text-xl">⏳</span>
                    <p className="font-medium text-gray-900">
                        Trial Active: <b>{daysRemaining} days</b> remaining.
                    </p>
                </div>
                <button 
                    onClick={() => navigate('/subscription')}
                    className="bg-black text-white px-4 py-1.5 rounded-lg text-sm font-semibold hover:bg-gray-800 transition"
                >
                    Upgrade Plan
                </button>
            </div>
        );
    }

    return null;
};

export default ExpirationAlert;